import { Deserializable } from './deserializable.model';

export class Domain implements Deserializable<any, Domain> {
  constructor(
    public id?: string,
    public key?: string,
    public name?: string,
    public term?: string,
    public type?: string
  ) {}

  deserialize(input: any): Domain {
    if (input == null) {
      return null;
    }

    this.id = input['id'];
    this.key = input['key'];
    this.name = input['name'];
    this.term = input['term'];
    this.type = input['type'];

    return this;
  }
}
